import React, { useEffect, useRef } from "react";

interface PincodeInputProps {
  length?: number;
  onChange?: (code: string) => void;
  resetStatus?: boolean;
  layout?: "default" | "clean";
}

const PincodeInput: React.FC<PincodeInputProps> = ({
  length = 6,
  onChange,
  resetStatus = false,
  layout = "default",
}) => {
  const inputsRef = useRef<HTMLInputElement[]>([]); //<HTMLInputElement[]>

  const handleChange = (value: string, index: number) => {
    if (!/^[0-9]?$/.test(value)) return;
    value = value.charAt(0);

    const trimmedValue = value.slice(-1); // Only last character
    const newCode = inputsRef.current
      .map((input) => input?.value || "")
      .join("");

    onChange?.(newCode);

    // Move to next input automatically
    if (newCode.length <= length) {
      if (trimmedValue && index < length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !inputsRef.current[index].value && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleReset = () => {
    for (let i = 0; i < length; i++) {
      inputsRef.current[i].value = "";
    }
  };

  useEffect(() => {
    if (resetStatus) {
      handleReset();
    }
    // eslint-disable-next-line
  }, [resetStatus]);

  return (
    <div className="d-center">
      <div
        className={`form-pincode-wrap ${
          layout === "clean" ? "underline-input" : ""
        }`}
        style={{ display: "flex", gap: "8px" }}
      >
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            ref={(el) => {
              if (el) inputsRef.current[index] = el;
            }}
            type="number"
            inputMode="numeric"
            maxLength={1}
            className="font-size-30"
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        ))}
      </div>
    </div>
  );
};

export default PincodeInput;
